<template>
    <div>
     <Banner/>
     <Overview/>
     <!-- <About/>
     <ProgramHighlights/>
     <WhyChooseWTI/>
     <DetailsPage/>
     <AlumniTestimonials/>
     <ThesisTeam/>
     <FAQ/>
     <FutureOfConservation/> -->



    </div>
</template>
<script>
import Banner from "./banner";
import Overview from "./overview";
// import About from "./about";
// import ProgramHighlights from "./programHighlights";
// import WhyChooseWTI from "./whyChooseWTI";
// import DetailsPage from "./detailsPage";
// import AlumniTestimonials from "./alumniTestimonials";
// import ThesisTeam from "./thesisTeam";
// import FAQ from "./faq";
// import FutureOfConservation from "./futureOfConservation";



export default {
  metaInfo() {
    return {
      title: "WTI-WILD BYTES | Wildlife Trust of India",
      meta: [
        {
          name: "description",
          content:
            "Read the latest WILD BYTES from Wildlife Trust of India - stories of wildlife conservation, protection, and preservation from across India.",
        },
        {
          name: "keywords",
          content:
            "WTI, Wildlife Trust of India, WILD BYTES, wildlife conservation, India, nature, conservation stories",
        },
        // Open Graph
        { property: "og:title", content: "WTI-WILD BYTES | Wildlife Trust of India" },
        {
          property: "og:description",
          content:
            "Read the latest WILD BYTES from Wildlife Trust of India - stories of wildlife conservation, protection, and preservation from across India.",
        },
        { property: "og:type", content: "website" },
        { property: "og:url", content: window.location.href },
        {
          property: "og:image",
          content: "https://www.wti.org.in/wp-content/uploads/2021/10/WTI-featured-image_3.jpg",
        },
        // Twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: "WTI-WILD BYTES | Wildlife Trust of India" },
        {
          name: "twitter:description",
          content:
            "Read the latest WILD BYTES from Wildlife Trust of India - stories of wildlife conservation, protection, and preservation from across India.",
        },
      ],
      link: [
        { rel: "canonical", href: window.location.href }
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "WTI-WILD BYTES",
            "url": "https://wildbytes.wti.org.in/",
            "description": "Wildlife Trust of India conservation stories and updates.",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://wildbytes.wti.org.in/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          }
        }
      ]
    };
  },
  components: {
    Banner,
    Overview,
    // About,
    // ProgramHighlights,
    // WhyChooseWTI,
    // DetailsPage,
    // AlumniTestimonials,
    // FAQ,
    // ThesisTeam,
    // FutureOfConservation
  },
};

</script>